"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var ChangelogModel = /** @class */ (function () {
    function ChangelogModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/changelog",
        };
        this.extract = this.extract.bind(this);
        this.cacheResponse = this.cacheResponse.bind(this);
    }
    ChangelogModel.prototype.extract = function (result) {
        return result.data;
    };
    ChangelogModel.prototype.cacheResponse = function (result) {
        return this.extract(result);
    };
    ChangelogModel.prototype.getEntries = function (params) {
        return this.$http
            .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(params))
            .then(this.cacheResponse);
    };
    ChangelogModel.prototype.getEntry = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResponse);
    };
    ChangelogModel.prototype.getLatest = function () {
        return this.$http
            .get(this.URLS.FETCH + "/latest")
            .then(this.cacheResponse);
    };
    return ChangelogModel;
}());
ChangelogModel.$inject = ["$http", "APPURL"];
exports.default = ChangelogModel;
